import React, { useState } from "react";
import { Mail, Phone } from "lucide-react";
import Footer from "../components/navigation/footer";

function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);

    try {
      const res = await fetch("https://api.arkbuild.com.au/api/enquiries", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setStatus("Thank you! Your message has been sent.");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setStatus("Server error. Please try again later.");
    }

    setLoading(false);
  };

  return (
    <div>
      <div className="min-h-screen bg-[#f3eddd] text-black pt-0 pb-20">
        <div className="w-full h-60 md:h-96 overflow-hidden">
          <img
            src="https://arkbuild-cdn.s3.ap-southeast-2.amazonaws.com/images/contact-hero.png"
            alt="Contact Banner"
            className="w-full h-full object-cover object-center"
          />
        </div>

        <div className="max-w-7xl mx-auto px-6 md:px-20 pt-20 space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold font-interTight">
            Get in Touch
          </h1>
          <p className="text-lg md:text-xl">
            We’d love to hear from you. Whether you have a question, a project
            idea, or just want to say hello, our team is here to help.
          </p>

          <form
            onSubmit={handleSubmit}
            className="mt-16 text-left bg-white p-8 rounded-xl shadow-md space-y-6"
          >
            <div className="flex">
              <Mail className="w-6 h-6 mb-3 text-[#F25E35]" />
              <h2 className="text-xl font-semibold pl-4">Message Us!</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium mb-1">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full p-3 border border-gray-300 rounded-md"
                  placeholder="Your name"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-3 border border-gray-300 rounded-md"
                  placeholder="you@example.com"
                  required
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                className="w-full p-3 border border-gray-300 rounded-md min-h-[150px]"
                placeholder="Type your message here..."
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="bg-[#F25E35] text-white px-6 py-3 rounded-md font-medium hover:opacity-90 transition"
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
            {status && (
              <p className="text-sm mt-2 text-gray-700 font-medium">{status}</p>
            )}
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ContactPage;
